/* CappyRoots third-party loading coordinator.
   Keeps measurement scripts untouched; delays only Gorgias chat until visitor intent or a short post-load fallback. */
(() => {
  'use strict';
  if (window.__cappyRootsThirdPartyDeferred) return;
  window.__cappyRootsThirdPartyDeferred = true;

  const gorgiasSources = [
    'https://config.gorgias.chat/bundle-loader/shopify/cappyroots-staging.myshopify.com',
    'https://config.gorgias.help/api/contact-forms/replace-mailto-script.js?shopName=cappyroots-staging'
  ];
  const minimumDelayMs = 5000;
  const fallbackDelayMs = 7000;
  const startedAt = performance.now();
  let loaded = false;
  let fallbackTimer = 0;

  const removeListeners = () => {
    window.removeEventListener('pointerdown', onIntent, true);
    window.removeEventListener('keydown', onIntent, true);
    window.removeEventListener('scroll', onIntent, true);
  };
  const appendScript = (src) => {
    if (document.querySelector(`script[data-cr-deferred-src="${src}"]`)) return;
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.dataset.crDeferredSrc = src;
    document.head.appendChild(script);
  };
  const loadGorgias = () => {
    if (loaded) return;
    loaded = true;
    if (fallbackTimer) window.clearTimeout(fallbackTimer);
    removeListeners();
    gorgiasSources.forEach(appendScript);
  };
  const loadWhenEligible = () => {
    const remaining = minimumDelayMs - (performance.now() - startedAt);
    if (remaining > 0) {
      window.setTimeout(loadGorgias, remaining);
      return;
    }
    loadGorgias();
  };
  const onIntent = () => loadWhenEligible();
  const schedule = () => {
    window.addEventListener('pointerdown', onIntent, { capture: true, passive: true, once: true });
    window.addEventListener('keydown', onIntent, { capture: true, once: true });
    window.addEventListener('scroll', onIntent, { capture: true, passive: true, once: true });
    fallbackTimer = window.setTimeout(loadGorgias, fallbackDelayMs);
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
